"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Info = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 90 90"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  d: "M45 0C20.147 0 0 20.147 0 45s20.147 45 45 45 45-20.147 45-45C89.972 20.159 69.841.028 45 0zm0 82C24.565 82 8 65.435 8 45S24.565 8 45 8s37 16.565 37 37c-.023 20.425-16.575 36.977-37 37zm-4-60a4 4 0 118 0 4 4 0 01-8 0zm13 41.999V70a.999.999 0 01-1 1H36.998a.999.999 0 01-.998-.999V64a.999.999 0 01.998-.999H41V41h-4.002a.999.999 0 01-.998-.999V34a.999.999 0 01.998-.999h11.003A.999.999 0 0149 34v29h4a.999.999 0 01.999.999z"
}));

var _default = Info;
exports.default = _default;